import AL_Birmingham_ATD_Oak_Mountain_Statepark1920px from 'images/cities/AL_Birmingham_ATD_Oak-Mountain-Statepark1920px.jpg';
import AL_Montgomery_Experience_Montgomery_Riverfront_Park1920px from 'images/cities/AL_Montgomery_Experience-Montgomery_Riverfront-Park1920px.jpg';
import Brown_Foundation_Lawn_Gathering1920px from 'images/cities/Brown-Foundation-Lawn-Gathering1920px.jpg';
import Clinton_Presidential_Center_and_Park_LittleRock_Arkansas_008_2000px from 'images/cities/Clinton-Presidential-Center-and-Park_LittleRock_Arkansas_008_2000px.jpg';
import Concert_on_Broadway1920px from 'images/cities/Concert-on-Broadway1920px.jpg';
import DJI_06821920px from 'images/cities/DJI_06821920px.jpg';
import FL_Visit_Orlando_0923_starflyer_gcm_2020_generic_8675_web72DPI_1920X1080 from 'images/cities/FL_Visit-Orlando_0923_starflyer-gcm-2020-generic-8675_web72DPI_1920X1080.jpg';
import FL_VTB_0924_paddleboard_28A0473_med_Web72DPI19220px from 'images/cities/FL_VTB_0924_paddleboard_28A0473_med_Web72DPI19220px.jpg';
import GA_Atlanta_downtown_skyline_shutterstock_10319672171920px from 'images/cities/GA_Atlanta_downtown-skyline_shutterstock_10319672171920px.jpg';
import Jacksonville_AdobeStock_75861357 from 'images/cities/Jacksonville_AdobeStock_75861357.jpeg';
import JH2_3817_edited2000px from 'images/cities/JH2_3817-edited2000px.jpg';
import Knoxville_AdobeStock_307020613 from 'images/cities/Knoxville_AdobeStock_307020613.jpeg';
import LA_NOLA_1025_ZSMITH_2025_04_16_097141920px from 'images/cities/LA_NOLA_1025_ZSMITH-2025-04-16-097141920px.jpg';
import LookoutMountain_HamiltonCo_Rock_City_NathanLambrecht_01169 from 'images/cities/LookoutMountain_HamiltonCo_Rock-City_NathanLambrecht_01169.jpg';
import MS_Visit_Jackson_1224_JXN_MS_Downtown_Skyline1920px from 'images/cities/MS_Visit-Jackson_1224_JXN-MS-Downtown-Skyline1920px.jpg';
import NC_Charlotte_Regional_VA_1123_Merchant_Trade_60169 from 'images/cities/NC_Charlotte-Regional-VA_1123_Merchant-Trade-60169.jpg';
import TN_Memphis_MT_0706_Vintage_car_outside_Sun_Studio_Alex_Shansky1920px from 'images/cities/TN_Memphis_MT_0706_Vintage-car-outside-Sun-Studio_Alex-Shansky1920px.jpg';
import TX_Dallas_Visit_Dallas_1_0925_Skyline_Downtown_Drone_201811920px from 'images/cities/TX_Dallas_Visit-Dallas_1_0925_Skyline_Downtown_Drone_201811920px.jpg';
import Waterfront_Park1920px from 'images/cities/Waterfront-Park1920px.jpg';
import Tallahassee_AdobeStock_249931993 from 'images/cities/Tallahassee_AdobeStock_249931993.jpeg';

const cityMap = [
	{ 
		key: 'atlanta-ga', 
		name: 'Atlanta, GA', 
		distance: "302.0 miles", 
		image: GA_Atlanta_downtown_skyline_shutterstock_10319672171920px, 
		href: 'https://www.google.com/maps/dir/?api=1&origin=Atlanta%2C+GA&destination=Santa+Rosa+Beach%2C+FL&travelmode=driving', 
		useLargeBody: true
	},
	{ 
		key: 'baton-rouge-la', 
		name: 'Baton Rouge, LA', 
		distance: "337.0 miles", 
		image: JH2_3817_edited2000px, 
		href: 'https://www.google.com/maps/dir/?api=1&origin=Baton+Rouge%2C+LA&destination=Santa+Rosa+Beach%2C+FL&travelmode=driving', 
		useLargeBody: true
	},
	{ 
		key: 'birmingham-al', 
		name: 'Birmingham, AL', 
		distance: "246.0 miles", 
		image: AL_Birmingham_ATD_Oak_Mountain_Statepark1920px, 
		href: 'https://www.google.com/maps/dir/?api=1&origin=Birmingham%2C+AL&destination=Santa+Rosa+Beach%2C+FL&travelmode=driving', 
		useLargeBody: true
	},
	{ 
		key: 'charlotte-nc', 
		name: 'Charlotte, NC', 
		distance: "560.0 miles", 
		image: NC_Charlotte_Regional_VA_1123_Merchant_Trade_60169, 
		href: 'https://www.google.com/maps/dir/?api=1&origin=Charlotte%2C+NC&destination=Santa+Rosa+Beach%2C+FL&travelmode=driving', 
		useLargeBody: true
	},
	{ 
		key: 'chattanooga-tn', 
		name: 'Chattanooga, TN', 
		distance: "394.0 miles", 
		image: LookoutMountain_HamiltonCo_Rock_City_NathanLambrecht_01169, 
		href: 'https://www.google.com/maps/dir/?api=1&origin=Chattanooga%2C+TN&destination=Santa+Rosa+Beach%2C+FL&travelmode=driving', 
		useLargeBody: true
	},
	{ 
		key: 'dallas-tx', 
		name: 'Dallas, TX', 
		distance: "739.0 miles", 
		image: TX_Dallas_Visit_Dallas_1_0925_Skyline_Downtown_Drone_201811920px, 
		href: 'https://www.google.com/maps/dir/?api=1&origin=Dallas%2C+TX&destination=Santa+Rosa+Beach%2C+FL&travelmode=driving', 
		useLargeBody: true
	},
	{ 
		key: 'houston-tx', 
		name: 'Houston, TX', 
		distance: "619.0 miles", 
		image: Brown_Foundation_Lawn_Gathering1920px, 
		href: 'https://www.google.com/maps/dir/?api=1&origin=Houston%2C+TX&destination=Santa+Rosa+Beach%2C+FL&travelmode=driving', 
		useLargeBody: true
	},
	{ 
		key: 'jackson-ms', 
		name: 'Jackson, MS', 
		distance: "343.0 miles", 
		image: MS_Visit_Jackson_1224_JXN_MS_Downtown_Skyline1920px, 
		href: 'https://www.google.com/maps/dir/?api=1&origin=Jackson%2C+MS&destination=Santa+Rosa+Beach%2C+FL&travelmode=driving', 
		useLargeBody: true
	},
	{ 
		key: 'jacksonville-fl', 
		name: 'Jacksonville, FL', 
		distance: "308.0 miles", 
		image: Jacksonville_AdobeStock_75861357, 
		href: 'https://www.google.com/maps/dir/?api=1&origin=Jacksonville%2C+FL&destination=Santa+Rosa+Beach%2C+FL&travelmode=driving', 
		useLargeBody: true
	},
	{ 
		key: 'knoxville-tn', 
		name: 'Knoxville, TN', 
		distance: "496.0 miles", 
		image: Knoxville_AdobeStock_307020613, 
		href: 'https://www.google.com/maps/dir/?api=1&origin=Knoxville%2C+TN&destination=Santa+Rosa+Beach%2C+FL&travelmode=driving', 
		useLargeBody: true
	},
	{ 
		key: 'little-rock-ar', 
		name: 'Little Rock, AR', 
		distance: "584.0 miles", 
		image: Clinton_Presidential_Center_and_Park_LittleRock_Arkansas_008_2000px, 
		href: 'https://www.google.com/maps/dir/?api=1&origin=Little+Rock%2C+AR&destination=Santa+Rosa+Beach%2C+FL&travelmode=driving', 
		useLargeBody: true
	},
	{ 
		key: 'louisville-ky', 
		name: 'Louisville, KY', 
		distance: "615.0 miles", 
		image: Waterfront_Park1920px, 
		href: 'https://www.google.com/maps/dir/?api=1&origin=Louisville%2C+KY&destination=Santa+Rosa+Beach%2C+FL&travelmode=driving', 
		useLargeBody: true
	},
	{ 
		key: 'memphis-tn', 
		name: 'Memphis, TN', 
		distance: "486.0 miles", 
		image: TN_Memphis_MT_0706_Vintage_car_outside_Sun_Studio_Alex_Shansky1920px, 
		href: 'https://www.google.com/maps/dir/?api=1&origin=Memphis%2C+TN&destination=Santa+Rosa+Beach%2C+FL&travelmode=driving', 
		useLargeBody: true
	},
	{ 
		key: 'mobile-al', 
		name: 'Mobile, AL', 
		distance: "140.0 miles", 
		image: DJI_06821920px, 
		href: 'https://www.google.com/maps/dir/?api=1&origin=Mobile%2C+AL&destination=Santa+Rosa+Beach%2C+FL&travelmode=driving', 
		useLargeBody: true
	},
	{ 
		key: 'montgomery-al', 
		name: 'Montgomery, AL', 
		distance: "153.0 miles", 
		image: AL_Montgomery_Experience_Montgomery_Riverfront_Park1920px, 
		href: 'https://www.google.com/maps/dir/?api=1&origin=Montgomery%2C+AL&destination=Santa+Rosa+Beach%2C+FL&travelmode=driving', 
		useLargeBody: true
	},
	{ 
		key: 'nashville-tn', 
		name: 'Nashville, TN', 
		distance: "434.0 miles", 
		image: Concert_on_Broadway1920px, 
		href: 'https://www.google.com/maps/dir/?api=1&origin=Nashville%2C+TN&destination=Santa+Rosa+Beach%2C+FL&travelmode=driving', 
		useLargeBody: true
	},
	{ 
		key: 'new-orleans-la', 
		name: 'New Orleans, LA', 
		distance: "293.0 miles", 
		image: LA_NOLA_1025_ZSMITH_2025_04_16_097141920px, 
		href: 'https://www.google.com/maps/dir/?api=1&origin=New+Orleans%2C+LA&destination=Santa+Rosa+Beach%2C+FL&travelmode=driving', 
		useLargeBody: true
	},
	{ 
		key: 'orlando-fl', 
		name: 'Orlando, FL', 
		distance: "398.0 miles", 
		image: FL_Visit_Orlando_0923_starflyer_gcm_2020_generic_8675_web72DPI_1920X1080, 
		href: 'https://www.google.com/maps/dir/?api=1&origin=Orlando%2C+FL&destination=Santa+Rosa+Beach%2C+FL&travelmode=driving', 
		useLargeBody: true
	},
	{ 
		key: 'tallahassee-fl', 
		name: 'Tallahassee, FL', 
		distance: "144.0 miles", 
		image: Tallahassee_AdobeStock_249931993, 
		href: 'https://www.google.com/maps/dir/?api=1&origin=Tallahassee%2C+FL&destination=Santa+Rosa+Beach%2C+FL&travelmode=driving', 
		useLargeBody: true
	},
	{ 
		key: 'tampa-fl', 
		name: 'Tampa, FL', 
		distance: "419.0 miles", 
		image: FL_VTB_0924_paddleboard_28A0473_med_Web72DPI19220px, 
		href: 'https://www.google.com/maps/dir/?api=1&origin=Tampa%2C+FL&destination=Santa+Rosa+Beach%2C+FL&travelmode=driving', 
		useLargeBody: true
	},
].sort((a, b) => b.distance.localeCompare(a.distance));

export default cityMap;